import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import Login from "@/views/Login.vue";

import UserList from "@/views/user/UserList.vue";
import UserDetails from "@/views/user/UserDetails.vue";

import AdminList from "@/views/admin/AdminList.vue";
import AdminDetails from "@/views/admin/AdminDetails.vue";

import ClientUserList from "@/views/client-user/ClientUserList.vue";
import ClientUserDetails from "@/views/client-user/ClientUserDetails.vue";

import MpUserList from "@/views/mp-user/MpUserList.vue";
import MpUserDetails from "@/views/mp-user/MpUserDetails.vue";
import JudiciaryUserList from "@/views/judiciary-user/JudiciaryUserList.vue";
import JudiciaryUserDetails from "@/views/judiciary-user/JudiciaryUserDetails.vue";
import JudiciaryClarificationList from "@/views/judiciary-user/JudiciaryClarificationList.vue";

import EventList from "@/views/event/EventList.vue";
import EventDetails from "@/views/event/EventDetails.vue";
import EventBulkAnalysis from "@/views/event/BulkAnalysis.vue";

import ProceedingList from "@/views/proceedings/ProceedingList.vue";
import ProceedingDetails from "@/views/proceedings/ProceedingDetails.vue";
import OtherProceedingList from "@/views/other-proceedings/OtherProceedingList.vue";
import OtherProceedingDetails from "@/views/other-proceedings/OtherProceedingDetails.vue";

// import AccreditationList from "@/views/accreditation/AccreditationList.vue";
// import AccreditationDetails from "@/views/accreditation/AccreditationDetails.vue";

import ObjectionList from "@/views/objection/ObjectionList.vue";
import ObjectionDetails from "@/views/objection/ObjectionDetails.vue";

import ClientList from "@/views/client/ClientList.vue";
import ClientDetails from "@/views/client/ClientDetails.vue";

import CreditorsList from "@/views/creditors-list/CreditorsList.vue";
import CreditorsInclude from "@/views/creditors-list/CreditorsListDetails.vue";


import EmployeeList from "@/views/employee/EmployeeList.vue";
import EmployeeDetails from "@/views/employee/EmployeeDetails.vue";

import IncidentList from "@/views/judicial-incident/IncidentList.vue";
import IncidentDetails from "@/views/judicial-incident/IncidentDetails.vue";

import LetterAnalysisList from "@/views/letter-analysis/LetterAnalysisList.vue";
import LetterAnalysisDetails from "@/views/letter-analysis/LetterAnalysisDetails.vue";

import CreditorsRequestsList from "@/views/creditors-requests/CreditorsRequestsList.vue";
import CreditorsRequestsDetails from "@/views/creditors-requests/CreditorsRequestsDetails.vue";

import QgcList from "@/views/qgc/QgcList.vue";
import QgcDetails from "@/views/qgc/QgcDetails.vue";
import QgcListAdjusted from "@/views/qgc/QgcListAdjusted.vue";
import QgcAdjustedDetails from "@/views/qgc/QgcAdjustedDetails.vue";
import QgcUnifiedList from "@/views/qgc/QgcUnifiedList.vue";
import QgcUnifiedDetails from "@/views/qgc/QgcUnifiedDetails.vue";

import ClientDocList from "@/views/client-doc/ClientDocList.vue";
import ClientDocDetails from "@/views/client-doc/ClientDocDetails.vue";

import FaqList from "@/views/faq/FaqList.vue";
import FaqDetails from "@/views/faq/FaqDetails.vue";

import HelpList from "@/views/help/HelpList.vue";
import HelpDetails from "@/views/help/HelpDetails.vue";

import GeneralMeetingList from "@/views/general-meeting/GeneralMeetingList.vue";
import GeneralMeetingDetails from "@/views/general-meeting/GeneralMeetingDetails.vue";
import GeneralMeetingVoting from "@/views/general-meeting/GeneralMeetingVoting.vue";
import GeneralMeetingPresence from "@/views/general-meeting/GeneralMeetingPresence.vue";

import DistrictList from "@/views/district/DistrictList.vue";
import DistrictDetails from "@/views/district/DistrictDetails.vue";

import PostList from "@/views/post/PostList.vue";
import PostDetails from "@/views/post/PostDetails.vue";

import RoleList from "@/views/role/RoleList.vue";
import RoleDetails from "@/views/role/RoleDetails.vue";

import DynamicTextList from "@/views/dynamic-text/DynamicTextList.vue";
import DynamicTextDetails from "@/views/dynamic-text/DynamicTextDetails.vue";

import DynamicInfoList from "@/views/dynamic-info/DynamicInfoList.vue";
import DynamicInfoDetails from "@/views/dynamic-info/DynamicInfoDetails.vue";

import TemplateDocList from "@/views/template-doc/TemplateDocList.vue";
import TemplateDocDetails from "@/views/template-doc/TemplateDocDetails.vue";

import LawyerList from "@/views/lawyer/LawyerList.vue";
import LawyerDetails from "@/views/lawyer/LawyerDetails.vue";

import ReportList from "@/views/report/ReportList.vue";
import ReportDetails from "@/views/report/ReportDetails.vue";

import ReportFileList from "@/views/report-file/ReportFileList.vue";
import ReportFileDetails from "@/views/report-file/ReportFileDetails.vue";

import ReportTypeList from "@/views/report-type/ReportTypeList.vue";
import ReportTypeDetails from "@/views/report-type/ReportTypeDetails.vue";

import ReportAnalysisList from "@/views/report-analysis/ReportAnalysisList.vue";
import ReportAnalysisDetails from "@/views/report-analysis/ReportAnalysisDetails.vue";

import OfficioAnalysisList from "@/views/officio-analysis/OfficioAnalysisList.vue";
import OfficioAnalysisDetails from "@/views/officio-analysis/OfficioAnalysisDetails.vue";

import PrivacyList from "@/views/privacy/PrivacyList.vue";
import PrivacyDetails from "@/views/privacy/PrivacyDetails.vue";

import PlanAdherenceList from "@/views/plan-adherence/PlanAdherenceList.vue";
import PlanAdherenceDetails from "@/views/plan-adherence/PlanAdherenceDetails.vue";
import PlanAdherenceCharts from "@/views/plan-adherence/PlanAdherenceCharts.vue";

import HomeBannerList from "@/views/home-banner/HomeBannerList.vue";
import HomeBannerDetails from "@/views/home-banner/HomeBannerDetails.vue";

import CertificateCreditClaimList from "@/views/certificate-credit-claim/CertificateCreditClaimList.vue";
import CertificateCreditClaimDetails from "@/views/certificate-credit-claim/CertificateCreditClaimDetails.vue";
import IssuedCreditCertificateList from "@/views/issued-credit-certificate/IssuedCreditCertificateList.vue";
import PaymentProofList from "@/views/payment-proof/PaymentProofList.vue";
import PaymentProofDetails from "@/views/payment-proof/PaymentProofDetails.vue";

import EventCreate from "@/views/event/EventCreate.vue";

import MostConsultedList from "@/views/most-consulted-process/MostConsultedList.vue"

import adminProfiles from "@/common/data/admin-profiles.data";

import * as jwt from "jwt-decode";

//the route guard
const guard = function (to: any, from: any, next: any) {
  const token = localStorage.getItem("token");

  const publicPath = to.matched.find(
    (path) => path.name === "Public" || path.name === "Home"
  );

  if (!token && to.path !== "/login" && !publicPath) {
    next({
      path: "/login",
    });
    return;
  }

  if (to.name == "Home") {
    next();
    return;
  }

  const resolvedToken = jwt(token);
  const user = resolvedToken.data;

  const permissions = to.meta.permissions;

  if (!permissions || !permissions.length) {
    next();
    return
  }

  if (!user || !user.roles || !user.roles.permissions) {
    next({
      path: "/home",
    });
    return;
  }

  const userPermissions = user.roles.permissions.map((permission: any) => permission.key);

  if (userPermissions.includes("*")) {
    next();
    return;
  };

  const hasPermission = permissions.some((permission) => {
    return (
      userPermissions.includes(permission) ||
      userPermissions.includes(permission + ".*") ||
      userPermissions.includes(permission.split(".")[0] + ".*")
    );
  });

  if (!hasPermission) {
    next({
      path: "/home",
    });
    return;
  }

  next();
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/layouts/Public.vue"),
    children: [
      {
        path: "/login",
        name: "login",
        component: Login,
      },
      {
        path: "/",
        redirect: "/login",
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/layouts/Private.vue"),
    beforeEnter: guard,
    children: [
      {
        path: "/home",
        name: "Home",
        component: Home,
      },
      {
        path: "/credores",
        name: "User",
        component: UserList,
        beforeEnter: guard,
        meta: { permissions: ['users.view'] }
      },
      {
        path: "/credores/:id",
        name: "User",
        component: UserDetails,
        beforeEnter: guard,
        meta: { permissions: ['users.find', 'users.update', 'users.create'] }
      },
      {
        path: "/admins",
        name: "Admin",
        component: AdminList,
        beforeEnter: guard,
        meta: { permissions: ['admins.view'] }
      },
      {
        path: "/admins/:id",
        name: "Admin",
        component: AdminDetails,
        beforeEnter: guard,
        meta: { permissions: ['admins.find', 'admins.update', 'admins.create'] }
      },
      {
        path: "/admins-devedora",
        name: "ClientUser",
        component: ClientUserList,
        beforeEnter: guard,
        meta: { permissions: ['clientusers.view'] }
      },
      {
        path: "/admins-devedora/:id",
        name: "ClientUser",
        component: ClientUserDetails,
        beforeEnter: guard,
        meta: { permissions: ['clientusers.find', 'clientusers.update', 'clientusers.create'] }
      },
      {
        path: "/admins-mp",
        name: "MpUser",
        component: MpUserList,
        beforeEnter: guard,
        meta: { permissions: ['mpusers.view'] }
      },
      {
        path: "/admins-mp/:id",
        name: "MptUser",
        component: MpUserDetails,
        beforeEnter: guard,
        meta: { permissions: ['mpusers.find', 'mpusers.update', 'mpusers.create'] }
      },
      {
        path: "/admins-juizo",
        name: "JudiciaryUser",
        component: JudiciaryUserList,
        beforeEnter: guard,
        meta: { permissions: ['judiciaryusers.view'] }
      },
      {
        path: "/admins-juizo/:id",
        name: "JudiciaryUserDetails",
        component: JudiciaryUserDetails,
        beforeEnter: guard,
        meta: { permissions: ['judiciaryusers.find', 'judiciaryusers.update', 'judiciaryusers.create'] }
      },
      {
        path: "/esclarecimentos-juizo",
        name: "JudiciaryClarification",
        component: JudiciaryClarificationList,
        beforeEnter: guard,
        meta: { permissions: ['judiciaryusers.view'] }
      },
      {
        path: "/cargos",
        name: "Roles",
        component: RoleList,
        beforeEnter: guard,
        meta: { permissions: ['roles.view'] }
      },
      {
        path: "/cargos/:id",
        name: "Roles",
        component: RoleDetails,
        beforeEnter: guard,
        meta: { permissions: ['roles.find', 'roles.update', 'roles.create'] }
      },
      {
        path: "/textos-automaticos",
        name: "DynamicText",
        component: DynamicTextList,
        beforeEnter: guard,
        meta: { permissions: ['dynamictexts.view'] }
      },
      {
        path: "/textos-automaticos/:id",
        name: "DynamicText",
        component: DynamicTextDetails,
        beforeEnter: guard,
        meta: { permissions: ['dynamictexts.find', 'dynamictexts.update', 'dynamictexts.create'] }
      },
      {
        path: "/divergencias",
        name: "Event",
        component: EventList,
        beforeEnter: guard,
        meta: { permissions: ['events.view'] }
      },
      {
        path: "/incidentes",
        name: "JudicialIncidents",
        component: IncidentList,
        beforeEnter: guard,
        meta: { permissions: ['judicialincidents.view'] }
      },
      {
        path: "/incidentes/:id",
        name: "JudicialIncidents",
        component: IncidentDetails,
        beforeEnter: guard,
        meta: { permissions: ['judicialincidents.find', 'judicialincidents.update'] }
      },
      {
        path: "/divergencias/:id",
        name: "Event",
        component: EventDetails,
        beforeEnter: guard,
        meta: { permissions: ['events.find', 'events.update'] }
      },
      {
        path: "/divergencias-inclusao",
        name: "Event",
        component: EventCreate,
        beforeEnter: guard,
        meta: { permissions: ['events.find', 'events.update'] }
      },
      {
        path: "/procuradores",
        name: "Lawyer",
        component: LawyerList,
        beforeEnter: guard,
        meta: { permissions: ['lawyers.view'] }
      },
      {
        path: "/procuradores/:id",
        name: "Lawyer",
        component: LawyerDetails,
        beforeEnter: guard,
        meta: { permissions: ['lawyers.find', 'lawyers.update', 'lawyers.create'] }
      },
      {
        path: "/modelo-documentos",
        name: "TemplateDoc",
        component: TemplateDocList,
        beforeEnter: guard,
        meta: { permissions: ['documentmodels.view'] }
      },
      {
        path: "/modelo-documentos/:id",
        name: "TemplateDoc",
        component: TemplateDocDetails,
        beforeEnter: guard,
        meta: { permissions: ['documentmodels.find', 'documentmodels.update', 'documentmodels.create'] }
      },
      {
        path: "/textos-dinamicos",
        name: "DynamicInfo",
        component: DynamicInfoList,
        beforeEnter: guard,
        meta: { permissions: ['dynamicinfos.view'] }
      },
      {
        path: "/textos-dinamicos/:id",
        name: "DynamicInfo",
        component: DynamicInfoDetails,
        beforeEnter: guard,
        meta: { permissions: ['dynamicinfos.find', 'dynamicinfos.update', 'dynamicinfos.create'] }
      },
      {
        path: "/casos",
        name: "Client",
        component: ClientList,
        beforeEnter: guard,
        meta: { permissions: ['clients.view'] }
      },
      {
        path: "/casos/:id",
        name: "Client",
        component: ClientDetails,
        beforeEnter: guard,
        meta: { permissions: ['clients.find', 'clients.update', 'clients.create'] }
      },
      {
        path: "/documentos",
        name: "Document",
        component: ClientDocList,
        beforeEnter: guard,
        meta: { permissions: ['clientdocs.view'] }
      },
      {
        path: "/documentos/:id",
        name: "Document",
        component: ClientDocDetails,
        beforeEnter: guard,
        meta: { permissions: ['clientdocs.find', 'clientdocs.update', 'clientdocs.create'] }
      },
      {
        path: "/comprovantes-pagamento",
        name: "PaymentProof",
        component: PaymentProofList,
        beforeEnter: guard,
        meta: { permissions: ['paymentproofs.view'] }
      },
      {
        path: "/comprovantes-pagamento/:id",
        name: "PaymentProof",
        component: PaymentProofDetails,
        beforeEnter: guard,
        meta: { permissions: ['paymentproofs.find', 'paymentproofs.update'] }
      },
      {
        path: "/faqs",
        name: "Faq",
        component: FaqList,
        beforeEnter: guard,
        meta: { permissions: ['faqs.view'] }
      },
      {
        path: "/faqs/:id",
        name: "Faq",
        component: FaqDetails,
        beforeEnter: guard,
        meta: { permissions: ['faqs.find', 'faqs.update', 'faqs.create'] }
      },
      {
        path: "/ajuda",
        name: "Help",
        component: HelpList,
        beforeEnter: guard,
        meta: { permissions: ['help.view'] }
      },
      {
        path: "/ajuda/:id",
        name: "Help",
        component: HelpDetails,
        beforeEnter: guard,
        meta: { permissions: ['help.find', 'help.update', 'help.create'] }
      },
      {
        path: "/adesao-plano",
        name: "PlanAdherence",
        component: PlanAdherenceList,
        beforeEnter: guard,
        meta: { permissions: ['planadherence.view'] }
      },
      {
        path: "/adesao-plano/graficos",
        name: "PlanAdherenceCharts",
        component: PlanAdherenceCharts,
        beforeEnter: guard,
        //meta: { permissions: ['planadherence.view'] }
      },
      {
        path: "/adesao-plano/:id",
        name: "PlanAdherence",
        component: PlanAdherenceDetails,
        beforeEnter: guard,
        meta: { permissions: ['planadherence.find', 'planadherence.update'] }
      },
      {
        path: "/pedidos-credores",
        name: "CreditorsRequests",
        component: CreditorsRequestsList,
        beforeEnter: guard,
        meta: { permissions: ['creditorsrequests.view'] }
      },
      {
        path: "/pedidos-credores/:id",
        name: "CreditorsRequests",
        component: CreditorsRequestsDetails,
        beforeEnter: guard,
        meta: { permissions: ['creditorsrequests.find', 'creditorsrequests.update', 'creditorsrequests.create'] }
      },
      {
        path: "/impugnacoes",
        name: "Proceedings",
        component: ProceedingList,
        beforeEnter: guard,
        meta: { permissions: ['proceedings.view'] }
      },
      {
        path: "/impugnacoes/:id",
        name: "Proceedings",
        component: ProceedingDetails,
        beforeEnter: guard,
        meta: { permissions: ['proceedings.find', 'proceedings.update', 'proceedings.create'] }
      },
      {
        path: "/outros-processos",
        name: "OtherProceedingList",
        component: OtherProceedingList,
        beforeEnter: guard,
        meta: { permissions: ["otherproceedings.view"] }
      },
      {
        path: "/outros-processos/novo",
        name: "OtherProceedingCreate",
        component: OtherProceedingDetails,
        beforeEnter: guard,
        meta: { permissions: ["otherproceedings.create"] }
      },
      {
        path: "/outros-processos/:id",
        name: "OtherProceedingDetails",
        component: OtherProceedingDetails,
        beforeEnter: guard,
        meta: { permissions: ["otherproceedings.find"] }
      },
      // {
      //   path: "/qgc-original",
      //   name: "Qgc",
      //   component: QgcList,
      //   beforeEnter: guard,
      //   meta: { permissions: ['usercreditors.view'] }
      // },
      // {
      //   path: "/qgc-ajustado",
      //   name: "Qgc",
      //   component: QgcListAdjusted,
      //   beforeEnter: guard,
      //   meta: { permissions: ['usercreditorsadjusted.view'] }
      // },
      // {
      //   path: "/qgc/:id",
      //   name: "Qgc",
      //   component: QgcDetails,
      //   beforeEnter: guard,
      //   meta: { permissions: ['usercreditors.find', 'usercreditors.update'] }
      // },
      // {
      //   path: "/qgc-ajustado/:id",
      //   name: "Qgc",
      //   component: QgcAdjustedDetails,
      //   beforeEnter: guard,
      //   meta: { permissions: ['usercreditorsadjusted.find', 'usercreditorsadjusted.update'] }
      // },
      {
        path: "/analise-oficio",
        name: "OfficioAnalysis",
        component: OfficioAnalysisList,
        beforeEnter: guard,
        meta: { permissions: ['officialanalysis.view'] }
      },
      {
        path: "/certidao-credito",
        name: "CertificateCreditClaim",
        component: CertificateCreditClaimList,
        beforeEnter: guard,
        //meta: { permissions: ['usercreditors.view'] }
      },
      {
        path: "/certidoes-credito",
        name: "IssuedCreditCertificate",
        component: IssuedCreditCertificateList,
        beforeEnter: guard,
        meta: { permissions: ['usercreditors.view'] }
      },
      {
        path: "/certidao-credito-detalhes",
        name: "CertificateCreditClaimDetails",
        component: CertificateCreditClaimDetails,
        beforeEnter: guard,
        //meta: { permissions: ['usercreditors.find', 'usercreditors.update'] }
      },
      {
        path: "/qgc",
        name: "Qgc",
        component: QgcUnifiedList,
        beforeEnter: guard,
       meta: { permissions: ['usercreditors.view'] }
      },
      {
        path: "/qgc/novo",
        name: "QgcNew",
        component: QgcUnifiedDetails,
        beforeEnter: guard,
        meta: { permissions: ['usercreditors.create'] }
      },
      {
        path: "/qgc/detalhes",
        name: "Qgc",
        component: QgcUnifiedDetails,
        beforeEnter: guard,
        meta: { permissions: ['usercreditors.find', 'usercreditors.update'] }
      },
      {
        path: "/analise-oficio/:id",
        name: "OfficioAnalysis",
        component: OfficioAnalysisDetails,
        beforeEnter: guard,
        meta: { permissions: ['officialanalysis.find', 'officialanalysis.update'] } 
      },
      {
        path: "/relatorio/:id",
        name: "Report",
        component: ReportDetails,
        beforeEnter: guard,
        meta: { permissions: ['reports.find', 'reports.update'] }
      },
      {
        path: "/relatorio",
        name: "Report",
        component: ReportList,
        beforeEnter: guard,
        meta: { permissions: ['reports.view'] }
      },
      {
        path: "/arquivo-relatorio",
        name: "ReportFile",
        component: ReportFileList,
        beforeEnter: guard,
        meta: { permissions: ['reportfiles.view'] }
      },
      {
        path: "/arquivo-relatorio/:id",
        name: "ReportFile",
        component: ReportFileDetails,
        beforeEnter: guard,
        meta: { permissions: ['reportfiles.find', 'reportfiles.update'] }
      },
      {
        path: "/modelo-relatorio",
        name: "ReportType",
        component: ReportTypeList,
        beforeEnter: guard,
        meta: { permissions: ['reporttypes.view'] }
      },
      {
        path: "/modelo-relatorio/:id",
        name: "ReportType",
        component: ReportTypeDetails,
        beforeEnter: guard,
        meta: { permissions: ['reporttypes.find', 'reporttypes.update'] },
      },
      {
        path: "/analise-relatorio",
        name: "ReportAnalysis",
        component: ReportAnalysisList,
        beforeEnter: guard,
        meta: { permissions: ['reportanalysis.view'] }
      },
      {
        path: "/analise-relatorio/:id",
        name: "ReportAnalysis",
        component: ReportAnalysisDetails,
        beforeEnter: guard,
        meta: { permissions: ['reporttypes.find', 'reporttypes.update'] },
      },
      {
        path: "/privacidade",
        name: "Privacy",
        component: PrivacyList,
        beforeEnter: guard,
        meta: { permissions: ['privacy.view'] }
      },
      {
        path: "/privacidade/:id",
        name: "Privacy",
        component: PrivacyDetails,
        beforeEnter: guard,
        meta: { permissions: ['privacy.find', 'privacy.update', 'privacy.create'] }
      },
      {
        path: "/revisao-credito",
        name: "ObjectionList",
        component: ObjectionList,
        beforeEnter: guard,
       meta: { permissions: ['objectionevents.view'] }
      },
      {
        path: "/revisao-credito/:id",
        name: "ObjectionDetails",
        component: ObjectionDetails,
        beforeEnter: guard,
        meta: { permissions: ['objectionevents.find', 'objectionevents.update'] }
      },
      {
        path: '/arquivo/:iid',
        name: 'Arquivo',
        component: () => import('@/views/FileView.vue'),
        props: true,
      },
      {
        path: "/banner-aviso",
        name: "HomeBanner",
        component: HomeBannerList,
        beforeEnter: guard,
      },
      {
        path: "/banner-aviso/:id",
        name: "HomeBanner",
        component: HomeBannerDetails,
        beforeEnter: guard,
      },
    ],
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

export default router;
